<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><i>The carriage … appeared more magnificent when seen than when described. Because of its wide fame it drew together many spectators; for from every city it came to, the people came out to meet it, and followed beside it when it went away, never wearied of their pleasure in the sight.</i></p>
<p class="right" style="margin-top:20px;"><i>Diodorus, Book XVII, 28</i></p>
<p class="center" style="margin-top:20px;"><img alt="img" src="Renault_TheNatureOfAlexander.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-eipgraph.vue?4be23814